import { Modal } from 'antd';
import React from 'react';

const UpcomingBirthdaysModal = ({ visible, onClose, upcomingBirthdays }) => {
  console.log("ub", upcomingBirthdays);
  
  const sortedBirthdays = upcomingBirthdays
    ? [...upcomingBirthdays].sort((a, b) => {
        const today = new Date();
        const currentYear = today.getFullYear();

        // Create birthday dates for this year
        const dateA = new Date(a.birthAnniversary);
        const dateB = new Date(b.birthAnniversary);

        const birthdayA = new Date(currentYear, dateA.getMonth(), dateA.getDate());
        const birthdayB = new Date(currentYear, dateB.getMonth(), dateB.getDate());

        // Adjust for wrapping around the new year
        const diffA =
          (birthdayA - today + 365 * 24 * 60 * 60 * 1000) % (365 * 24 * 60 * 60 * 1000);
        const diffB =
          (birthdayB - today + 365 * 24 * 60 * 60 * 1000) % (365 * 24 * 60 * 60 * 1000);

        return diffA - diffB;
      })
    : [];
  return (
    <Modal
      title="Upcoming Birthdays"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      {/* {upcomingBirthdays && upcomingBirthdays.length > 0 ? ( */}
      {sortedBirthdays && sortedBirthdays.length > 0 ? (
        <ul>
          {sortedBirthdays.map((user) => {
            const birthAnniversary = new Date(user.birthAnniversary);
            const formattedBirthdate = birthAnniversary.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

            return (
              <li key={user.id}>
                {user.firstName} {user.lastName} - {formattedBirthdate}
              </li>
            );
          })}
        </ul>
      ) : (
        <p>No upcoming birthdays in the next 30 days.</p>
      )}
    </Modal>
  );
};

export default UpcomingBirthdaysModal;
